import { supabase } from '../supabase.js';

/**
 * Fetch from a view or table with optional filters/pagination.
 * Logs the response size in dev so we can see egress impact.
 *
 * @param {string} table              - table or view name
 * @param {object} [opts]
 * @param {string} [opts.select]      - columns string for .select() (default '*')
 * @param {object} [opts.eq]          - { col: value } pairs for .eq filters
 * @param {object} [opts.gte]         - { col: value } pairs for .gte filters
 * @param {object} [opts.lte]         - { col: value } pairs for .lte filters
 * @param {[number,number]} [opts.range] - [from, to] for pagination
 * @param {string} [opts.order]       - column to order by
 * @param {boolean} [opts.ascending]  - default true
 */
export async function pageQuery(table, opts = {}) {
  const t0 = performance.now();
  const selectOpts = opts.count ? { count: 'exact' } : {};
  let q = supabase.from(table).select(opts.select || '*', selectOpts);

  if (opts.eq)  for (const [c, v] of Object.entries(opts.eq))  q = q.eq(c, v);
  if (opts.gte) for (const [c, v] of Object.entries(opts.gte)) q = q.gte(c, v);
  if (opts.lte) for (const [c, v] of Object.entries(opts.lte)) q = q.lte(c, v);
  if (opts.order) q = q.order(opts.order, { ascending: opts.ascending !== false });
  if (opts.range) q = q.range(opts.range[0], opts.range[1]);

  const { data, error, count } = await q;
  const dt = (performance.now() - t0).toFixed(0);
  const bytes = data ? new Blob([JSON.stringify(data)]).size : 0;

  if (import.meta.env.DEV) {
    console.log(`[egress] ${table}  ${data?.length ?? 0} rows  ${(bytes/1024).toFixed(1)} KB  ${dt}ms`);
  }

  if (error) throw error;
  return { data, count };
}
